(function () {
  const STYLE_ID = 'rx-collection-thumb-styles'

  function injectStyles() {
    if (document.getElementById(STYLE_ID)) return
    const style = document.createElement('style')
    style.id = STYLE_ID
    style.textContent = `
      .rx-collection-thumb-wrap.is-loading .js-rx-collection-thumb {
        opacity: 0;
        visibility: hidden;
      }
      .rx-collection-thumb-wrap.is-ready .js-rx-collection-thumb {
        opacity: 1;
        visibility: visible;
        transition: opacity 0.15s ease;
      }
    `
    document.head.appendChild(style)
  }

  function normalizeRxColor(color) {
    return String(color || '').toLowerCase().replace(/-/g, '')
  }

  function isRx02Image(url) {
    return /_02[._]/.test(String(url))
  }

  function getRxColorFromUrl(url) {
    const part = String(url).split('_Rx_').pop()
    if (!part) return ''
    return part.split(/[.?&#]/)[0]
  }

  function findRxLensImageUrl(images, lensColor) {
    if (!Array.isArray(images) || !images.length || !lensColor) return null
    const target = normalizeRxColor(lensColor)
    return images.find((url) => {
      if (!isRx02Image(url)) return false
      return normalizeRxColor(getRxColorFromUrl(url)) === target
    }) || null
  }

  function revealThumb(wrapper) {
    wrapper.classList.remove('is-loading')
    wrapper.classList.add('is-ready')
    wrapper.dataset.rxCollectionThumbInit = 'true'
  }

  function applyThumbSrc(wrapper, img, url) {
    if (!url) {
      revealThumb(wrapper)
      return
    }

    const onReady = () => {
      img.removeEventListener('load', onReady)
      img.removeEventListener('error', onReady)
      revealThumb(wrapper)
    }

    img.addEventListener('load', onReady)
    img.addEventListener('error', onReady)
    img.src = url

    if (img.complete) {
      onReady()
    }
  }

  function initRxCollectionThumb(wrapper) {
    if (!wrapper || wrapper.dataset.rxCollectionThumbInit === 'true') return
    if (wrapper.dataset.rxProductType !== 'Prescription') return

    const img = wrapper.querySelector('.js-rx-collection-thumb')
    if (!img) return

    let images = []
    try {
      images = JSON.parse(wrapper.dataset.rxImages || '[]')
    } catch (error) {
      console.warn('[rx-collection-thumb] Failed to parse image list', error)
    }

    const useFirstImage = wrapper.dataset.rxUseFirstImage === 'true'
    let targetUrl = null

    if (useFirstImage) {
      targetUrl = images[0] || null
    } else {
      targetUrl = findRxLensImageUrl(images, wrapper.dataset.rxLensColor) || null
    }

    applyThumbSrc(wrapper, img, targetUrl)
  }

  function initAllRxCollectionThumbs(root) {
    injectStyles()
    const scope = root && root.querySelectorAll ? root : document
    scope.querySelectorAll('[data-rx-collection-thumb][data-rx-product-type="Prescription"]').forEach(initRxCollectionThumb)
  }

  window.NevenRxCollectionThumb = {
    init: initRxCollectionThumb,
    initAll: initAllRxCollectionThumbs,
    findRxLensImageUrl
  }

  document.addEventListener('DOMContentLoaded', () => initAllRxCollectionThumbs())
})()
